// extracted by mini-css-extract-plugin
export default {"puzzle":"QuizPuzzle_puzzle__vnnoX"};